import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import LayerImage from 'ol/layer/Image';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import DragPan from 'ol/interaction/DragPan';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import PinchRotate from 'ol/interaction/PinchRotate';
import Overlay from 'ol/Overlay';
import axios from 'axios';
export default {
  name: 'mapv2assembly',
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  components: {},
  meta: {
    title: 'openlayermap组件'
  },
  data() {
    return {
      mapcontainer: '',
      map: ''
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {},
  methods: {
    initMap() {
      // 加载静态图片
      const imageExtent = transformExtent([120.127473, 30.315084, 120.34433, 30.521861], 'EPSG:4326', 'EPSG:3857');
      const imageProjection = new Projection({
        code: 'xkcd-image',
        units: 'pixels',
        extent: imageExtent
      });
      const staticImageLayer = new LayerImage({
        source: new SourceImagestatic({
          attributions: '© <a href="https://xkcd.com/license.html">xkcd</a>',
          url: 'https://p.ananas.chaoxing.com/star3/origin/aca88cc41f71f15059aa8a7060d5960b.png',
          projection: imageProjection,
          imageExtent: imageExtent
        }),
        opacity: 1
      });

      // 加载GeoJson
      const jsonlayer = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: (process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin) + '/frontendTest1/openlayers/data/330113_full.json'
        }),
        style: [new Style({
          stroke: new StyleStroke({
            color: 'rgba(0, 0, 0, 0.6)',
            width: 3
          }),
          fill: new StyleFill({
            color: 'rgba(238, 238, 238, 0.5)'
          })
        })]
      });
      this.mapcontainer = this.$refs[`map${this.id}`];
      this.map = new Map({
        layers: [
        // 加载高德地图瓦片作为底图
        new TileLayer({
          source: new XYZ({
            url: 'http://webrd03.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
          })
        }),
        // staticImageLayer,
        jsonlayer],
        target: this.mapcontainer,
        view: new View({
          center: transform([120.299376, 30.419025], 'EPSG:4326', 'EPSG:3857'),
          zoom: 12
        })
      });
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
    },
    singleclick(val) {
      // 高德坐标
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      console.log('coordinate: ' + coordinateArr[0].toFixed(6) + ',' + coordinateArr[1].toFixed(6));
    },
    markerclick(evt, type) {
      // console.log(evt)
    },
    markermove(evt, type) {
      // console.log(evt)
    }
  }
};